// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__gWIEh","loaderOuter":"PageOverlayLoader_loaderOuter__2Ibww"};